import { asLabel } from '@shure/shared/models';

export interface MessageListItem {
	role: MessageRoleEnum;
	type?: string;
	content?: string;
	options?: string[];
	messageId?: string;
	feedbacktype?: UserFeedbackEnum;
	isFinalResponse?: boolean;
}

export enum MessageRoleEnum {
	User = 'user',
	Assistant = 'assistant'
}

export enum ChatResponseTypeEnum {
	Status = 'status',
	FinalState = 'final_state',
	WaitingForInput = 'waiting_for_input'
}

export enum UserFeedbackEnum {
	Positive = 'positive',
	Negative = 'negative',
	Neutral = 'neutral'
}

export const assistantResponseFeedbackLabels = {
	positive: [
		{ key: 'factually-correct', label: asLabel('cloud.shared.chat-assistant.factually-correct') },
		{ key: 'easy-to-understand', label: asLabel('cloud.shared.chat-assistant.easy-to-understand') },
		{ key: 'informative', label: asLabel('cloud.shared.chat-assistant.informative') },
		{ key: 'creative-interesting', label: asLabel('cloud.shared.chat-assistant.creative-interesting') },
		{ key: 'other', label: asLabel('cloud.shared.chat-assistant.other') }
	],
	negative: [
		{ key: 'offensive-unsafe', label: asLabel('cloud.shared.chat-assistant.offensive-unsafe') },
		{ key: 'not-factually-correct', label: asLabel('cloud.shared.chat-assistant.not-factually-correct') },
		{ key: 'generic-bland', label: asLabel('cloud.shared.chat-assistant.generic-bland') },
		{ key: 'didnt-follow-instructions', label: asLabel('cloud.shared.chat-assistant.didnt-follow-instructions') },
		{ key: 'wrong-language', label: asLabel('cloud.shared.chat-assistant.wrong-language') },
		{ key: 'other', label: asLabel('cloud.shared.chat-assistant.other') }
	],
	neutral: []
};
